module.exports = __webpack_public_path__ + "img/setor-harian-kurir.da1a5548.svg";